module.exports = __webpack_public_path__ + "static/img/2.08025484.png";